import * as React from "react"

import { cn } from "@/lib/utils"

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-20 w-full rounded-xl border border-border/60 bg-background/50 px-3 py-2 text-base transition-all outline-none placeholder:text-muted-foreground/70 focus-ring disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-error aria-invalid:ring-error md:text-sm",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }

